import Repository, { baseURL } from "./Repository"

import { createAsyncThunk } from "@reduxjs/toolkit"

export const branchesInfo = createAsyncThunk('Branch_Born', async () => {
    return await Repository.post(`${baseURL}/Branch_Born`)
        .then(res => {

            return res.data
        }).catch(error => {
            return error.response.data

        })
})
export const newofBranch = createAsyncThunk('LineNews', async () => {
    return await Repository.post(`${baseURL}/LineNews`)
        .then(res => {

            return res.data
        }).catch(error => {
            return error.response.data

        })
})
export const newBranches = createAsyncThunk('schedule', async () => {
    return await Repository.post(`${baseURL}/schedule `)
        .then(res => {

            return res.data
        }).catch(error => {
            return error.response.data

        })
})